import { Dialog, DialogBody, DialogTitle, EditProps } from '@/components/base/dialog'
import { PencilIcon, PhotoIcon } from '@heroicons/react/24/solid'
import { Tabs } from '@/components/tabs'
import { Form as DetailsForm } from './edit_form'
import { EditCategoryQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'
import { EditImages } from './edit_images'

export const EditDialog = ({ id, open, setOpen }: EditProps) => {
  const tabs = [
    { name: 'Details', component: <DetailsForm id={id} />, icon: PencilIcon },
    { name: 'Images', component: <EditImages categoryId={id} />, icon: PhotoIcon },
  ]

  const { data, loading } = useQuery<EditCategoryQuery>(Query, { variables: { filters: { idEq: id } } })

  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle><div>{ loading || !data ? <Loading /> : data.categories.nodes[0].name }</div></DialogTitle>
        <DialogBody>
          <Tabs tabs={tabs} />
        </DialogBody>
      </Dialog>
    </>
  )
}
